import React from "react";
import Meeting3 from "../../assets/meeting3.jpeg";

// --- Reusable Page Banner Component ---
const PageBanner = ({
  title = "",
  subtitle = "",
  bgImage = Meeting3,
  // heightClass: allows customization of height if needed, defaults to min-h-[500px]
  heightClass = "min-h-[500px]",
}) => {
  return (
    // Section Container: Full width, centering content
    <section
      className={`relative w-full ${heightClass} flex items-center justify-center overflow-hidden`}
    >
      {/* --- Background Image Layer --- */}
      <div className="absolute inset-0 z-0">
        <img
          src={bgImage}
          alt={title}
          // Effect: Slight zoom on hover for a subtle feel
          className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-[2000ms] ease-in-out"
        />

        {/* --- Dark Overlay Layer (Makes text readable) --- */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30"></div>
      </div>

      {/* --- Content Layer (Text) --- */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Animation: Fade In Up */}
        <div className="animate-fade-in-up">
          {/* Optional Breadcrumb */}
          <nav className="flex justify-center mb-6">
            <ol className="flex items-center space-x-2 text-sm text-blue-200">
              <li>
                <a href="/" className="hover:text-white transition-colors"></a>
              </li>
              <li>
                <span className="text-gray-400">/</span>
              </li>
              <li className="text-white font-medium">{title}</li>
            </ol>
          </nav>

          {/* Main Title */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-6 tracking-tight drop-shadow-lg">
            {title}
          </h1>

          {/* Subtitle / Description */}
          {subtitle && (
            <p className="text-lg sm:text-xl text-gray-200 max-w-3xl mx-auto font-light leading-relaxed">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default PageBanner;
